<template>
    <div>
        <input
            class="forecast-checkbox"
            :v-model="localValue"
            :id="forecastId"
            type="checkbox"
            @change="e => $emit('updateValue', e.target.checked)"
        />
        <label :for="forecastId"></label>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true
        },
        forecastId: {
            type: Number,
            required: true
        }
    },
    model: {
        prop: "model",
        event: "updateValue"
    },
    data() {
        return {
            localValue: false
        };
    },
    created() {
        this.localValue = this.value;
    }
};
</script>
<style scoped lang="scss">
.forecast-checkbox {
    position: absolute; // take it out of document flow
    opacity: 0; // hide it

    & + label {
        position: relative;
        cursor: pointer;
        padding: 0;
    }

    // Box.
    & + label:before {
        content: "";
        margin-right: 10px;
        display: inline-block;
        vertical-align: text-top;
        width: 25px;
        height: 25px;
        background: white;
        border: thin solid grey;
        border-radius: 3px;
        transition: 0.3s ease-in-out;
        cursor: pointer !important;
    }

    // Box hover
    &:hover + label:before {
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
    }

    // Box focus
    &:focus + label:before {
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
    }

    // Box checked
    &:checked + label:before {
        background: grey;
    }

    // Disabled state label.
    &:disabled + label {
        color: #b8b8b8;
        cursor: pointer !important;
    }

    // Disabled box.
    &:disabled + label:before {
        box-shadow: none;
        background: #ddd;
    }

    // Checkmark. Could be replaced with an image
    &:checked + label:after {
        content: "";
        position: absolute;
        background-image: url("../../../../assets/check-icon.svg");
        width: 60%;
        height: 60%;
        background-size: contain;
        background-repeat: no-repeat;
        top: 6px;
        left: 3px;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// CheckBoxTable.vue?7d3d5e30